
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authorship",
      function () {
        return require("private-next-pages/authorship/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/authorship"])
      });
    }
  